import React from 'react';
import { useTranslation } from 'react-i18next';
import './TrustBar.css';

function TrustBar() {
  const { t } = useTranslation();
  const items = t('trustBar.items', { returnObjects: true });

  return (
    <div className="trust-bar bg-navy-mid border-bottom border-navy-light">
      <div className="container">
        <ul className="trust-bar-list list-unstyled d-flex flex-wrap justify-content-center gap-3 gap-md-4 mb-0 py-3">
          {Array.isArray(items) &&
            items.map((item, i) => (
              <li key={i} className="trust-bar-item small text-white-50 fw-medium">
                {item}
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
}

export default TrustBar;
